// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Cwj6M","image":"Header_image__1jxIq","name":"Header_name__1rLhv","info":"Header_info__3jwJH","infoRow":"Header_infoRow__tNXNr"};